import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = {
  products: () => axios.get(`${API}/products`).then((r) => r.data),
  featured: () => axios.get(`${API}/products/featured`).then((r) => r.data),
  adminProducts: (key) => axios.get(`${API}/admin/products`, { headers: { "x-admin-key": key } }).then((r) => r.data),
  saveMeta: (id, data, key) => axios.put(`${API}/admin/products/${id}/meta`, data, { headers: { "x-admin-key": key } }).then((r) => r.data),
  subscribers: (key) => axios.get(`${API}/admin/subscribers`, { headers: { "x-admin-key": key } }).then((r) => r.data),
  sync: (key) => axios.post(`${API}/printful/sync`, {}, { headers: { "x-admin-key": key } }).then((r) => r.data),
  product: (slug) => axios.get(`${API}/products/${slug}`).then((r) => r.data),
  gatherings: () => axios.get(`${API}/gatherings`).then((r) => r.data),
  rsvp: (id, data) => axios.post(`${API}/gatherings/${id}/rsvp`, data).then((r) => r.data),
  orderBySession: (sessionId) => axios.get(`${API}/orders/by-session/${encodeURIComponent(sessionId)}`).then((r) => r.data),
  track: (orderNumber) => axios.get(`${API}/orders/${encodeURIComponent(orderNumber)}/track`).then((r) => r.data),
  updateDrop: (data, key) => axios.post(`${API}/drop`, data, { headers: { "x-admin-key": key } }).then((r) => r.data),
  createCheckout: (data) => axios.post(`${API}/payments/checkout`, data).then((r) => r.data),
  shippingQuote: (data) => axios.post(`${API}/shipping/quote`, data).then((r) => r.data),
  paymentStatus: (sessionId) => axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data),
  drop: () => axios.get(`${API}/drop`).then((r) => r.data),
  newsletter: (email) => axios.post(`${API}/newsletter`, { email }).then((r) => r.data),
};
